export const handleFrontend = () => {

  // clicks to .ep-header__burger adds the active class to .ep-header__menuitems
  const burger = document.querySelector('.ep-header__burger')
  const menuitems = document.querySelector('.ep-header__menuitems')
  const close = document.querySelector('.ep-header__close')

  burger.addEventListener('click', () => {
    menuitems.classList.toggle('active')
    close.classList.toggle('active')
  })

  //clicks to .ep-header__close removes the active class from .ep-header__menuitems

  close.addEventListener('click', () => {
    menuitems.classList.remove('active')
    close.classList.remove('active')
  })



  jQuery(document).ready(function () {
    jQuery('.programme__item__content').hide();
    jQuery('.programme__item__title').click(function () {
      jQuery(this).next().slideToggle();
      jQuery(this).find('.programme__item__title__open').toggle();
      jQuery(this).find('.programme__item__title__close').toggle();
    });
    
    // If they click on .itemqsm__title__togglebutton, .itemqsm__accordion should toggle, and "fas fa-plus open" should hide and  "fas fa-minus close" should show

    jQuery('.itemqsm__accordion').hide();
    jQuery('.itemqsm__thetoggle').click(function () {
      jQuery(this).next().slideToggle();
      jQuery(this).find('.open').toggle();
      jQuery(this).find('.close').toggle();
    });

    function closePopup() {
      jQuery('.popup').hide();
    }

    // Event handler for opening the popup
    jQuery('a[href="#contact"]').click(function(event) {
      event.preventDefault(); // Prevent the default action
      jQuery('.popup').show();     // Show the popup
    });

    // Event handler for closing the popup when close button is clicked
    jQuery('.popup__close').click(function(event) {
      event.preventDefault(); // Prevent the default action
      closePopup();           // Close the popup
    });

    // Event handler for closing the popup when clicking on the overlay
    jQuery('.popup').click(function(event) {
      if (event.target === this) {  // Check if the clicked element is the .popup itself
        closePopup();               // Close the popup
      }
    });

    // Prevent closing when clicking inside the popup content
    jQuery('.popup__content').click(function(event) {
      event.stopPropagation();  // Prevent the click from bubbling up to the .popup
    });
  });
  
}